<template>
  <div id="textPrivacidade">
    <v-flex xs12>
      <v-card color="primary">
        <v-card-text class="display-1 white--text">Remover Conta - Ommini PréPago</v-card-text>
      </v-card>
      <v-flex xs10 offset-xs1 class="headline"></v-flex>
      <v-flex xs12 class="body-3 font-weight-regular" style="margin-left:15px;margin-top:100px">
       
        <div id="aq-block-2844-4">
          <div>
          
            <p>Você tem certeza que deseja remover sua conta?
              </p><p>Todos os dados pessoais serão removidos.</p>
              <p> Os dados relacionados a movimentações (talvez não apaguemos) mas vamos omitir a informação.
            </p>
          
          </div>
        </div>
        <div id="aq-block-2844-5"> 
          <v-btn class="white--text" @click="removerConta()" color="sucesso" value="justify">
          Sim eu Quero
          <v-icon right>check</v-icon>
        </v-btn>
         
        </div>
      
      </v-flex>
    </v-flex>
    <v-snackbar
              :timeout="tempo"
              :color="error"
              :multi-line="'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbar"
            >
              {{ textSnack }}
              <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
            </v-snackbar>

            <v-snackbar
              :timeout="5000"
              :color="sucesso"
              :multi-line="'multi-line'"
              :vertical="mode === 'vertical'"
              v-model="snackbarSuccess"
            >
              {{textSnackSuccess}}
              <v-btn dark flat @click.native="snackbarSuccess = false">Fechar</v-btn>
            </v-snackbar>
  </div>
</template>

<script>
import { HTTP } from "../services/http.axios.js";
export default {
  
  props: ["cpf"],
  mounted () {
    this.dados.cpf= this.$route.params.cpf;  
  },
  
  data: () => ({
    dados:{cpf:''},
    textSnack: "",
      textSnackSuccess: "",
      show1: false,
      show2: false,
      snackbar: false,
      snackbarSuccess: false,
      tempo: 5000,
      mode: "",
      info: "f1f1f1",
      error: "error",
      sucesso: "sucesso",
      loading: false,
  }),

  methods: {
    removerConta() {
      HTTP.post(`https://v2api.omminiprepago.com.br/removeConta`, this.dados)
        .then(response => {
          if (response.data.error) {
            this.textSnack = response.data.error.cpf;
            this.snackbar = true;
          } else {
           
          
            this.textSnackSuccess = "Email enviado para confirmar a remoção";
            this.snackbarSuccess = true;
           
            //return true;
          }

          //  console.log(response.data.token)
        })
        .catch(e => {
          this.loading = false;
          console.log("log" + e.response.data.error);

          if (!Array.isArray(e.response.data.error)) {
            let itens = [];
            for (var prop in e.response.data.error) {
              itens.push(e.response.data.error[prop][0]);
            }
            this.textSnack = itens.join(" ");
            this.snackbar = true;
          } else {
            this.textSnack = e.response.data.error;
            this.snackbar = true;
          }
        });
    }
  }
};
</script>
<style>
#textPrivacidade {
  text-align: left;
}
.display-2 {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Removerconta.vue